import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'
import {energyConsumptionChartWidgetTranslations} from '@widgets/energy-consumption-chart'
import {planningCommentsWidgetTranslations} from '@widgets/planning-comments'
import {planningScheduleChartWidgetTranslations} from '@widgets/planning-schedule-chart'

import {FEATURE_NAMESPACE} from '../consts'

const operatorViewTranslationModule: TranslationModule = {
  namespace: FEATURE_NAMESPACE,
  resources: {
    'cs-CZ': () => import('./cs_CZ.json'),
    'de-DE': () => import('./de_DE.json'),
    'en-GB': () => import('./en_GB.json'),
    'en-US': () => import('./en_US.json'),
    'es-ES': () => import('./es_ES.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'it-IT': () => import('./it_IT.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'sv-SE': () => import('./sv_SE.json')
  }
}

const externalPackageTranslations = combineTranslationBundles([
  planningScheduleChartWidgetTranslations,
  energyConsumptionChartWidgetTranslations,
  planningCommentsWidgetTranslations
])

export const operatorViewFeatureTranslations = combineTranslationBundles([
  externalPackageTranslations,
  operatorViewTranslationModule
])
